import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSidenav } from '@angular/material/sidenav';
import { Router, NavigationEnd } from '@angular/router';
import { Notificacao } from '../../../shared/interfaces/notificacao';
import { NotificacaoService } from '../../../shared/services/notificacao.service';
import { BehaviorSubject } from 'rxjs';
import { NotificationDetailComponent } from './notification-detail/notification-detail.component';
import { JwtAuthService } from '../../services/auth/jwt-auth.service';
import { CadCompromissoService } from '../../services/cad-compromisso.service';
import { CadCompromisso } from '../../interfaces/cad-compromisso';
    import { combineLatest, Subscription } from 'rxjs';
    import { switchMap, filter } from 'rxjs/operators';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html'
})
export class NotificationsComponent implements OnInit {
  @Input() notificPanel;

  // notifications : Notificacao[] = [];
  //change notification to BehaviorSubject
  notifications = new BehaviorSubject<Notificacao[]>([]);
  notificationsLocal = new BehaviorSubject<Notificacao[]>([]);

  notificationsInfokaw = new BehaviorSubject<Notificacao[]>([]);

  notificationsCompromisso = new BehaviorSubject<Notificacao[]>([]);

  constructor(
    private dialog: MatDialog,
    private router: Router,
    private jwtAuth: JwtAuthService,
    private notificacaoService: NotificacaoService,
    private compromissoService: CadCompromissoService) {}

  ngOnInit() {
    

    combineLatest([
      this.jwtAuth.itemRemoto$,
      this.jwtAuth.item$,
      this.jwtAuth.filial$
    ]).subscribe(([itemRemoto, item]) => {
      // console.log(`NOTIFICATIONSCOMPONENT - ITEMREMOTO: ${JSON.stringify(itemRemoto)}`);
      // console.log(`NOTIFICATIONSCOMPONENT - ITEM: ${JSON.stringify(item)}`);
      // console.log(`NOTIFICATIONSCOMPONENT - FILIAL: ${JSON.stringify(filial)}`);

      // Decide filialCodigo based on empresaRemota presence
      let filialCodigo: string | undefined;

      if (itemRemoto && itemRemoto.filialCodigo) {
        console.log(`NOTIFICATIONSCOMPONENT - FILIALCODIGO FROM ITEMREMOTO: ${itemRemoto.filialCodigo}`);
        filialCodigo = itemRemoto.filialCodigo.replace(/\D/g, '');
        console.log(`NOTIFICATIONSCOMPONENT - FILIALCODIGO AFTER REPLACE: ${filialCodigo}`);
        this.loadNotifications(filialCodigo);
      } else if (item && item.filialCodigo) {
        console.log(`NOTIFICATIONSCOMPONENT - FILIALCODIGO FROM ITEM: ${item.filialCodigo}`);
        filialCodigo = item.filialCodigo.replace(/\D/g, '');
        console.log(`NOTIFICATIONSCOMPONENT - FILIALCODIGO AFTER REPLACE: ${filialCodigo}`);
        this.loadNotifications(filialCodigo);
      } else {
        console.log(`NOTIFICATIONSCOMPONENT - FILIALCODIGO NOT FOUND`);
        filialCodigo = undefined;
        this.notificationsLocal.next([]);
        this.notificationsInfokaw.next([]);

      }

    });

    // Merge notificationsLocal, notificationsInfokaw e notificationsCompromisso
    combineLatest([
      this.notificationsLocal,
      this.notificationsInfokaw,
      this.notificationsCompromisso
    ]).subscribe(([local, infokaw, compromissos]) => {
      const itens = [...(local ?? []), ...(infokaw ?? []), ...(compromissos ?? [])];
      const itensUnicos = itens.filter((item, index, self) => index === self.findIndex((t) => (t.uuid === item.uuid)));
      this.notifications.next(itensUnicos);
      this.setTotalNotif(itensUnicos.length);
    });

    // Update total notifications when notifications change
    this.notifications.subscribe((notificacoes) => {
      this.setTotalNotif(notificacoes.length);
      console.log("TL notificacoes:", notificacoes.length);
    });

    // Close panel on navigation
    this.router.events.subscribe((routeChange) => {
      if (routeChange instanceof NavigationEnd) {
        this.notificPanel.close();
      }
    });
  }

  loadNotifications(filialCodigo: string) {
    // Notificações da API "mesma origem" (nuvem => infokaw.com.br; intranet => /api local).
    this.notificacaoService.getNotificacoesValidas(filialCodigo).subscribe(
      notificacoes => {
        this.notificationsLocal.next((notificacoes ?? []).map(notificacao => { return { ...notificacao, fromInfokaw: false }; }));
      },
      () => { this.notificationsLocal.next([]); }
    );

    // Notificações CENTRAIS da Infokaw (sempre https://infokaw.com.br/api, via getNotificacoesValidasInfokaw).
    // Na intranet o apiURL é local ('/api'), então essa é a única forma de receber os avisos/versão/
    // promoção/cobrança publicados pelo suporte. Sem internet, a chamada falha e mantém só as locais.
    // Na nuvem o resultado coincide com o de cima e é deduplicado por uuid no merge.
    this.notificacaoService.getNotificacoesValidasInfokaw(filialCodigo).subscribe(
      notificacoes => {
        this.notificationsInfokaw.next((notificacoes ?? []).map(notificacao => { return { ...notificacao, fromInfokaw: true }; }));
      },
      () => { this.notificationsInfokaw.next([]); }
    );

    this.compromissoService.getPendentesHoje().subscribe(
      compromissos => {
        const notifs: Notificacao[] = (compromissos ?? []).map(c => ({
          id: c.id as any,
          uuid: c.uuid ?? `compromisso-${c.id}`,
          titulo: `📋 ${c.titulo}`,
          texto: c.descricao ?? '',
          tipoNotificacao: 'COMPROMISSO' as any,
          tipoNotificacaoTexto: 'TXT' as any,
          desativado: false,
          inicio: c.dataFim ? new Date(c.dataFim) : new Date(),
          issueDate: c.issueDate ? new Date(c.issueDate) : new Date(),
          updatedAt: c.updatedAt ? new Date(c.updatedAt) : new Date(),
          fromInfokaw: false,
          outrosDados: `/utilitario/compromisso/compromisso`,
          _compromisso: c
        } as any));
        this.notificationsCompromisso.next(notifs);
      },
      () => { this.notificationsCompromisso.next([]); }
    );
  }

  private setTotalNotif(total = 0) {
    this.notificPanel.totalNotif = total;
  }

  closePanel() {
    this.notificPanel.close();
  }

  clearAll(e) {
    e.preventDefault();
    // this.notifications = [];
    this.notifications.next([]);
    this.setTotalNotif(0);
  }

  openPopUp(data: Notificacao) {
    const dialogRef: MatDialogRef<any> = this.dialog.open(NotificationDetailComponent, {
      width: '80%',
      disableClose: true,
      data: { title: '', payload: data }
    })
  }
  
  getIconByType(type: string) {
    switch (type) {
      case 'AVISO':       return 'info';
      case 'COBRANCA':    return 'attach_money';
      case 'VERSAO':      return 'update';
      case 'PROMOCAO':    return 'local_offer';
      case 'COMPROMISSO': return 'event';
      default:            return 'notifications';
    }
  }

  getColorByType(type: string) {
    switch (type) {
      case 'AVISO':       return 'accent';
      case 'COBRANCA':    return 'warn';
      case 'VERSAO':      return 'primary';
      case 'PROMOCAO':    return 'accent';
      case 'COMPROMISSO': return 'warn';
      default:            return 'accent';
    }
  }

  isCompromisso(n: Notificacao): boolean {
    return (n.tipoNotificacao as any) === 'COMPROMISSO';
  }

  /** Nome do responsável quando o compromisso está vinculado/preenchido */
  getCompromissoResponsavel(n: Notificacao): string {
    const c = (n as any)._compromisso as CadCompromisso;
    return c?.responsavel?.trim() || '';
  }

  /** Faixa de horário do compromisso (HH:mm – HH:mm), vazio quando sem hora definida */
  getCompromissoHorario(n: Notificacao): string {
    const c = (n as any)._compromisso as CadCompromisso;
    if (!c) return '';
    const ini = this.formatHora(c.dataInicio);
    const fim = this.formatHora(c.dataFim);
    if (ini && fim) return `${ini} – ${fim}`;
    return ini || fim || '';
  }

  private formatHora(d: Date): string {
    if (!d) return '';
    const dt = new Date(d);
    if (isNaN(dt.getTime())) return '';
    const h = dt.getHours();
    const m = dt.getMinutes();
    if (h === 0 && m === 0) return '';
    return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
  }

}
